import React, { Fragment } from "react";
import LoginComponent from "../../components/LoginComponent";

// acceso: "superadmin" en el login privado del superadmin; vacío en el login normal
const HomePages = ({ acceso }) => {
  return (
    <Fragment>
      <div className="container">
        <LoginComponent acceso={acceso} />
      </div>
    </Fragment>
  );
};
export default HomePages;
